angular
    .module("app")
    .controller("sublocazioneNoleggioCtrl", function (
        $scope,
        RichiestePostVendita,
        $transactionFactory
    ) {
        if (!$transactionFactory.get()) {
            $scope.richiestePostVendita = RichiestePostVendita.build();
        } else {
            $scope.richiestePostVendita = $transactionFactory.get();
            $transactionFactory.clear();
        }
    });